import { Component } from "react";
import { EquipoMedico } from "./equipoMedico";

export class MedicoPersonal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      configurations: {},
      doctorInfo: {
        Error: null,
        MedicoSede: {},
        Sede: {}
      },
      mapOptions: {
        center: {
          lat: 4.6482837,
          lng: -74.2478952
        },
        zoom: 12
      },
      showingInfoWindow: false,
      activeMarker: {},
      selectedPlace: {},
      selectedOption: "Cómo Llegar",
      typeUser: this.props.typeUser
    };
    this.directionsDisplay = undefined;
    this.isEmpty = this.isEmpty.bind(this);
    this.googleChecker = this.googleChecker.bind(this);
    this.renderMap = this.renderMap.bind(this);
    this.renderInfoWindow = this.renderInfoWindow.bind(this);
  }

  componentDidMount() {
    setTimeout(() => {
      this.googleChecker();
    }, 500);
  }

  isEmpty(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }

  /*shouldComponentUpdate(nextProps, nextState){ 

    console.log( nextProps.doctorInfo)
    this.setState((prevState, props) => {
      this.setState({ doctorInfo:  props.doctorInfo, configurations: props.configurations });
    });
    return !this.isEmpty(nextProps.configurations && nextProps.doctorInfo)
  }*/

  googleChecker() {
    // check for maps in case you're using other google api
    // if(!window.google || !window.google.maps) {
    //   setTimeout(googleChecker, 100);
    // } else {
    // the google maps api is ready to use, render the map
    this.props.getDoctorInfo(
      this.props.userDocumentNumber,
      this.props.userDocumentType,
      doctorInfo => {
        this.setState({ doctorInfo }, () => {
          //this.renderMap();
        });
      }
    );
    //this.renderMap();
    // }
  }

  renderInfoWindow() {
    let url = _spPageContextInfo.siteAbsoluteUrl.split("/salud");
    url = url[0] + this.state.doctorInfo.Sede.UrlImagenSede;
    const image =
      this.state.doctorInfo.Sede && this.state.doctorInfo.Sede.UrlImagenSede
        ? '<img src="' + url + '"  />'
        : "";
    const tituloUrl =
      this.state.doctorInfo.Sede !== null &&
      this.state.doctorInfo.Sede.TituloUrl
        ? '<h3 id="firstHeading" class="firstHeading">' +
          this.state.doctorInfo.Sede.TituloUrl +
          "</h3>"
        : "";
    const phone =
      this.state.doctorInfo.Sede && this.state.doctorInfo.Sede.Telefono
        ? '<p class="text-map"><i class="fa fa-phone" aria-hidden="true"></i> ' +
          this.state.doctorInfo.Sede.Telefono +
          "</p>"
        : "";
    const address =
      this.state.doctorInfo.Sede && this.state.doctorInfo.Sede.Direccion
        ? '<p class="text-map"><i class="fa fa-map-marker aria-hidden="true""></i> ' +
          this.state.doctorInfo.Sede.Direccion +
          "</p>"
        : "";
    // const schedule = this.state.doctorInfo.Sede.Horario ? '<p class="p-clock text-map"><i class="fa fa-clock-o" aria-hidden="true"></i> ' + this.state.doctorInfo.Sede.Horario + '</p>': '';
    // const parking = this.state.doctorInfo.Sede.Parqueadero ? '<p class="text-map"><i class="fa fa-car" aria-hidden="true"></i> ' + this.state.doctorInfo.Sede.Parqueadero.split('\n').join('<br />') + '</p>' : '';
    const urlMoreInfo =
      this.state.doctorInfo.Sede && this.state.doctorInfo.Sede.UrlMasInformacion
        ? '<button type="button" class="btn btn-primary btn-more"><a target="_blank" href="' +
          this.state.doctorInfo.Sede.UrlMasInformacion +
          '">Más información</a></button>'
        : "";
    return (
      '<div id="marker-info-container" class="marker-info-container infosede">' +
      '<div id="content" class="content">' +
      '<div id="siteNotice">' +
      '<div id="headContent" class="headContent">' +
      image +
      tituloUrl +
      "</div>" +
      '<div id="bodyContent" class="bodyContent">' +
      phone +
      address +
      // schedule +
      // parking +
      '<select id="how-to-arrive-select"><option value="">Cómo Llegar</option><option value="DRIVING">Vehículo particular</option><option value="TRANSIT">Transporte público</option><option value="WALKING">Caminando</option></select>' +
      urlMoreInfo +
      '<a class="cerrarCaja"></a>' +
      "</div>" +
      "</div>" +
      "</div>" +
      "</div>"
    );
  }

  renderMap() {
    const latLng = {
      lat: this.state.mapOptions.center.lat,
      lng: this.state.mapOptions.center.lng
    };
    const directionsService = new google.maps.DirectionsService();
    const geocoder = new google.maps.Geocoder();

    let currentLatLng = {
      lat: 0,
      lng: 0
    };

    // create map instance
    const mapOptions = {
      center: latLng,
      zoom: 12
    };
    const map = new google.maps.Map(this.refs.mapContainer, mapOptions);

    if (this.state.doctorInfo.Sede !== null) {
      const marker = new google.maps.Marker({
        position: latLng,
        map: map,
        animation: google.maps.Animation.DROP,
        title: "Compensar"
      });

      this.directionsDisplay = new google.maps.DirectionsRenderer();

      const infowindow = new google.maps.InfoWindow({
        content: this.renderInfoWindow(),
        maxWidth: 280,
        positionMiddleOfWindow: true
      });

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
          currentLatLng = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
        });
      } else {
        console.log("Geolocation is not supported for this Browser/OS.");
      }

      marker.addListener("click", () => {
        infowindow.open(map, marker);
        const map = this.map;
        const howToArriveSelect = document.getElementById(
          "how-to-arrive-select"
        );
        const closeMarker = document.querySelector(".cerrarCaja");
        closeMarker.addEventListener("click", e => {
          infowindow.close();
        });

        if (!currentLatLng) {
          howToArriveSelect.style.display = "none";
        } else {
          howToArriveSelect.addEventListener("change", e => {
            infowindow.close();

            navigator.permissions
              .query({ name: "geolocation" })
              .then(function(result) {
                if (result.state == "granted") {
                  console.log(result.state);
                } else if (result.state == "prompt") {
                  console.log(result.state);
                  navigator.geolocation.getCurrentPosition(
                    revealPosition,
                    positionDenied,
                    geoSettings
                  );
                } else if (result.state == "denied") {
                  console.log(result.state);
                }
                result.onchange = function() {
                  console.log(result.state);
                };
              });

            const directionsService = new google.maps.DirectionsService();

            this.directionsDisplay.setMap(map);
            if (howToArriveSelect.value) {
              directionsService.route(
                {
                  origin: { lat: currentLatLng.lat, lng: currentLatLng.lng },
                  destination: { lat: latLng.lat, lng: latLng.lng },
                  travelMode: google.maps.TravelMode[howToArriveSelect.value]
                },
                (response, status) => {
                  if (status == "OK") {
                    this.directionsDisplay.setDirections(response);
                    this.directionsDisplay.setOptions({
                      polylineOptions: {
                        strokeWeight: 4,
                        strokeOpacity: 1,
                        strokeColor: "red"
                      }
                    });
                  } else {
                    console.log("Directions request failed due to " + status);
                  }
                }
              );
            }
          });
        }
      });
    }
  }

  activeMap = e => {
    e.preventDefault();
    if (this.state.doctorInfo) {
      this.renderMap();
    }
  };

  render() {
    const UrlAgenda = this.props.configurations[
      "BotonAgendarCitaMedicoHomeURL"
    ];
    return (
      <div className="personal-doctor-container">
        <div className="doctor-detail">
          <div className="col-md-4 col-sm-4 col-xs-12">
            <h3 className="doctor-title">
              {this.props.configurations["MedicoPersonalTitulo"] || ""}
            </h3>
            <img
              className="doctor-image"
              onContextMenu={e => {
                e.preventDefault();
                return false;
              }}
              src={
                this.props.configurations["MiMedicoPersonalTitulo"] &&
                this.state.doctorInfo.MedicoSede &&
                this.state.doctorInfo.MedicoSede.ExisteImagen
                  ? _spPageContextInfo.siteAbsoluteUrl +
                    "/" +
                    this.state.doctorInfo.MedicoSede.UrlImagen
                  : _spPageContextInfo.siteAbsoluteUrl +
                    "/Style Library/Images/" +
                    this.props.configurations["MedicoPersonalAvatarDoctor"]
              }
            />
            {this.state.doctorInfo.MedicoSede &&
            this.state.doctorInfo.MedicoSede.NumeroDocumento ? (
              <div className="doctor-assigned">
                <h5>
                  {this.state.doctorInfo.MedicoSede.Dr}{" "}
                  {this.state.doctorInfo.MedicoSede.Nombre}
                </h5>
                <p>
                  Especialidad: {this.state.doctorInfo.MedicoSede.Especialidad}{" "}
                </p>
                {this.state.doctorInfo.Sede ? (
                  <p className="location">
                    <i className="fa fa-map-marker" />{" "}
                    <span>{this.state.doctorInfo.Sede.TituloUrl}</span>
                  </p>
                ) : (
                  ""
                )}
                {this.props.configurations[
                  "TextoBotonAgendarCitaCSVisibleBool"
                ] ? (
                  <div className="schedule">
                    <a
                      type="button"
                      href={UrlAgenda}
                      className="btn btn-primary"
                    >
                      {this.props.configurations["TextoBotonAgendarCita"] || ""}
                    </a>
                  </div>
                ) : null}

                {this.state.typeUser === "CE" &&
                (this.props.configurations[
                  "CambiarMedicoPersonalCSVisibleBool"
                ] ||
                  this.props.configurations[
                    "CambiarMedicoPersonalBeneficiariosCSVisibleBool"
                  ]) ? (
                  <div className="change-doctor">
                    {this.props.user === "contributor" ? (
                      <a
                        href={
                          this.props.configurations["CambiarMedicoPersonalURL"]
                        }
                      >
                        {this.props.configurations["CambiarMedicoPersonal"] ||
                          ""}
                      </a>
                    ) : (
                      <a
                        href={
                          this.props.configurations[
                            "CambiarMedicoPersonalBeneficiariosURL"
                          ]
                        }
                      >
                        {this.props.configurations[
                          "CambiarMedicoPersonalBeneficiarios"
                        ] || ""}
                      </a>
                    )}
                  </div>
                ) : null}
              </div>
            ) : (
              <div className="doctor-unassigned">
                <h5>No Asignado</h5>
                <p className="doctor-unassigned-text">
                  {this.props.configurations["TextoPersonalMedicoNoAsignado"] ||
                    ""}
                </p>
              </div>
            )}
          </div>
          <div className="col-md-8 col-sm-8 col-xs-12">
            <div className="medical-offices-container">
              <div id="map" ref="mapContainer">
                <img
                  src={`${
                    _spPageContextInfo.siteAbsoluteUrl
                  }/PublishingImages/sedes/mapa-sedes-prev1.jpg`}
                  alt="Sedes de compensar"
                  onClick={this.activeMap}
                  style={{
                    height: "100%",
                    width: "100%",
                    "object-fit": "cover",
                    cursor: "pointer"
                  }}
                />
              </div>
            </div>
          </div>
          <hr className="hr-line-div-elem" />
        </div>
        <br />
        <div className="row">
          <div className="col-sm-12">
            <EquipoMedico
              userDocument={this.props.userDocumentNumber}
              userDocumentType={this.props.userDocumentType}
              configurations={this.props.configurations}
            />
          </div>
        </div>
      </div>
    );
  }
}
